import * as React from 'react';
import type { SVGProps } from 'react';
const SvgInProgressIconRing = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={42}
    height={42}
    fill="none"
    viewBox="0 0 42 42"
    {...props}
  >
    <circle
      cx={21}
      cy={21}
      r={19.5}
      fill="#FFF7DB"
      stroke="#FFE89E"
      strokeWidth={3}
    />
    <path
      stroke="#F2A218"
      strokeLinecap="round"
      strokeWidth={3}
      d="M21 40.5a19.5 19.5 0 1 1 18.546-13.474"
    />
  </svg>
);
export default SvgInProgressIconRing;
